import { ListConfigs } from "../../app/sharedComponent/SearchList/SearchList.types"

export const LATEXTS = {
  addModalHeader: 'Add Live Agent',
  editModalHeader: 'Edit Live Agent',
  addModalSuccess: 'Live agent created successfully',
  editModalSuccess: 'Live agent updated successfully',
  duplicateEmailMsg: 'Email already exists',
}
export const LISTCONFIGS:ListConfigs[] = [
  {
    headerName: 'Name',
    apiFieldName: 'liveAgentName',
    columnWidth: '150',
    type: 'TEXT',
  },
  {
    headerName: 'Email ID',
    apiFieldName: 'liveAgentEmail',
    columnWidth: '150',
    type: 'TEXT',
  },
  {
    headerName: 'Vendor Name',
    apiFieldName: 'vendorName',
    columnWidth: '150',
    type: 'TEXT',
  },
  {
    headerName: 'Status',
    apiFieldName: 'liveAgentStatus',
    columnWidth: '150',
    type: 'ACTIVE_BADGE',
  },
]
